<div class="menu" [class.menu--collapsed]="collapsed && !overlay" [class.menu--overlay]="overlay">
  <div class="menu__header">
    <button *ngIf="overlay" mat-icon-button type="button" class="menu__close" (click)="requestClose()" [attr.aria-label]="'app.menu.links.closeMenu' | translate">
      <mat-icon>close</mat-icon>
    </button>
    <img src="/assets/images/crest.svg" alt="JDR" class="logo">
    <div class="brand">
      <span class="brand__title">JDR</span>
      <span class="brand__subtitle">Personnages</span>
    </div>
  </div>

  <nav class="menu__nav" aria-label="Navigation principale" (click)="onLinkClick($event)">
    <div class="menu__section">
      <span class="menu__section-label">{{ 'app.menu.sections.application' | translate }}</span>
      <a mat-button routerLink="/character-sheets"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="iconsOnly ? ('app.menu.links.characterSheets' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>menu_book</mat-icon>
        <span>{{ 'app.menu.links.characterSheets' | translate }}</span>
      </a>
    </div>

    <div class="menu__section" *ngIf="isAdmin$ | async">
      <span class="menu__section-label">{{ 'app.menu.sections.configuration' | translate }}</span>
      <a mat-button routerLink="/admin/workspace-settings"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="iconsOnly ? ('app.menu.links.configuration' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>settings</mat-icon>
        <span>{{ 'app.menu.links.configuration' | translate }}</span>
      </a>
    </div>
  </nav>

  <div class="menu__footer" (click)="onLinkClick($event)">
    <a mat-button routerLink="/settings"
       routerLinkActive="active"
       class="navigation-link"
       [matTooltip]="iconsOnly ? ('app.menu.links.account' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>manage_accounts</mat-icon>
      <span>{{ 'app.menu.links.account' | translate }}</span>
    </a>

    <a *ngIf="!overlay" mat-button class="navigation-link" (click)="toggleCollapse()"
       [matTooltip]="iconsOnly ? ('app.menu.links.expandMenu' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>{{ collapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
      <span>{{ collapsed ? ('app.menu.links.expandMenu' | translate) : ('app.menu.links.collapseMenu' | translate) }}</span>
    </a>

    <a mat-button class="navigation-link" (click)="logout()"
       [matTooltip]="iconsOnly ? ('app.menu.logoutButtonLabel' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>logout</mat-icon>
      <span>{{ 'app.menu.logoutButtonLabel' | translate }}</span>
    </a>
  </div>
</div>
